import classNames from 'classnames'
import React from 'react'
import {useExperiments} from '@wix/yoshi-flow-editor'
import {ExperimentNames} from '@wix/wix-events-commons-statics'
import s from './price-item.scss'
import {PriceItemProps, PriceItemSize} from './interfaces'

export const PriceItem: React.FC<PriceItemProps> = ({
  hook,
  label,
  price,
  size = PriceItemSize.small,
}: PriceItemProps) => {
  const {experiments} = useExperiments()
  const ticketPickerRedesignEnabled = experiments.enabled(ExperimentNames.TicketPickerRedesign)

  if (!price) {
    return null
  }

  return (
    <div
      className={classNames(getClassName(size), s.container, ticketPickerRedesignEnabled ? s.margin : s.marginOld)}
      role="text"
      data-hook={hook}
    >
      <p className={s.inlineFlex}>{label}</p>
      <p className={s.inlineFlex}>{price}</p>
    </div>
  )
}

const getClassName = (size: PriceItemSize) => {
  switch (size) {
    case PriceItemSize.extraBig:
      return s.extraBig
    case PriceItemSize.big:
      return s.big
    case PriceItemSize.medium:
      return s.medium
    case PriceItemSize.small:
    default:
      return s.small
  }
}
